import {
  AdddestinationCountryData,
  FeeLookupSuccess,
  SendCommitSuccess,
  SendValidate,
  SendValidateSuccess,
  GetRefundSuccess,
  TransactionStatusSuccess,
  PrepareTransaction,
  SetLocationActionTrns,
  ClearSelectedLocationAction,
  ConfirmRefundSuccess,
  SetPaymentOption,
  SetSelectedBankAccount,
} from './transaction.actions';
import { createReducer, on, Action } from '@ngrx/store';
import { _Bottom } from '@angular/cdk/scrolling';
import { RefundResponse, TransactionState } from './types';
import { AddNewBankAccount, DpSendCommitSuccess, DpSendValidate, DpSendValidateSuccess, GetBankAccountsSuccess, GetBankGFFPFieldsSuccess, GetPaymentPlatformMetaDataSuccess } from '../digital-payment/digital-payment.action';
import { GetFeeQuoteSucessAction } from '../fee-quote';

export const initialState: TransactionState = {
  // TODO -- fix typing
  destinationCountryData: {} as any,
  feeLookupResponse: {} as any,
  sendValidateRequest: {} as any,
  sendValidateResponse: {} as any,
  createPaymentResponse: {} as any,
  sendCommitResponse: {} as any,
  getRefundResponse: {} as RefundResponse,
  confirmRefundResponse: {} as any,
  selectedLocation: {} as any,
  paymentOption: null,
  selectedBankAccount: null,
  availableBankAccounts: [],
  bankGFFPFields: null,
};

export function TransactionReducer(
  state: TransactionState | undefined,
  action: Action
) {
  return reducer(state, action);
}

export const reducer = createReducer(
  initialState,
  on(AdddestinationCountryData, (state, { destinationCountryData }) => ({
    ...state,
    destinationCountryData: {
      ...destinationCountryData,
    },
  })),
  on(
    SetPaymentOption,
    (state, { paymentOption }) =>
      ({
        ...state,
        paymentOption
      } as TransactionState)
  ),
  on(
    SetSelectedBankAccount,
    (state, { selectedBankAccount }) =>
      ({
        ...state,
        selectedBankAccount
      } as TransactionState)
  ),
  on(
    GetBankAccountsSuccess,
    (state, getBankAccountsResponse) =>
      ({
        ...state,
        availableBankAccounts: getBankAccountsResponse.bankAccounts
      } as TransactionState)
  ),
  on(
    AddNewBankAccount,
    (state, {newBankAccountInfo, bankName, targetAccountProfileId, accountNumberMasked}) =>
      ({
        ...state,
        availableBankAccounts: [
          ...state.availableBankAccounts, 
          {
            newBankAccountInfo: {...newBankAccountInfo},
            bankName,
            targetAccountProfileId,
            accountNumberMasked
          }
        ],
        selectedBankAccount: {
          newBankAccountInfo: {...newBankAccountInfo},
          bankName,
          targetAccountProfileId,
          accountNumberMasked
        }
      } as TransactionState)
  ),
  on(
    GetBankGFFPFieldsSuccess,
    (state, { fieldInfo }) =>
      ({
        ...state,
        bankGFFPFields: fieldInfo
      } as TransactionState)
  ),
  on(
    GetFeeQuoteSucessAction,
    (state, feeLookupResponse) =>
    ({
      ...state,
      paymentOption: {
        ...state.paymentOption!,
        serviceOptionRoutingCode: feeLookupResponse?.feeLookupResponse?.transactions[0]?.serviceOptionRoutingCode ?? ''
      }
    })
  ),
  on(
    FeeLookupSuccess,
    (state, { feeLookupResponse }) =>
      ({
        ...state,
        feeLookupResponse: {
          ...feeLookupResponse,
        },
      } as TransactionState)
  ),
  on(SendValidate, (state, { transactionId, payload }) => ({
    ...state,
    sendValidateRequest: {
      ...payload,
    },
  })),
  on(DpSendValidate, (state, { sendValidatePayload }) => ({
    ...state,
    sendValidateRequest: {
      ...sendValidatePayload,
    },
  })),
  on(SendValidateSuccess, (state, { sendValidateResponse }) => ({
    ...state,
    sendValidateResponse: {
      ...sendValidateResponse,
    },
  })),
  on(DpSendValidateSuccess, (state, { sendValidateResponse }) => ({
    ...state,
    sendValidateResponse: {
      ...sendValidateResponse,
    },
  })),
  on(SendCommitSuccess, (state, { sendCommitResponse }) => ({
    ...state,
    sendCommitResponse: {
      ...sendCommitResponse,
    },
  })),
  on(GetPaymentPlatformMetaDataSuccess, (state, { getPaymentPlatformMetaDataResponse }) => ({
    ...state,
    createPaymentResponse: getPaymentPlatformMetaDataResponse
  })),
  on(DpSendCommitSuccess, (state, { sendCommitResponse }) => ({
    ...state,
    sendCommitResponse: {
      ...sendCommitResponse,
    },
  })),
  on(TransactionStatusSuccess, (state, { transactionStatusResponse }) => ({
    ...state,
    transactionStatusResponse: {
      ...transactionStatusResponse,
    },
  })),
  on(GetRefundSuccess, (state, { getRefundResponse }) => ({
    ...state,
    getRefundResponse: {
      ...getRefundResponse,
    },
  })),
  on(SetLocationActionTrns, (state, { selectedLocation }) => ({
    ...state,
    selectedLocation: selectedLocation,
  })),
  on(ClearSelectedLocationAction, (state) => ({
    ...state,
    selectedLocation: {},
  })),
  on(ConfirmRefundSuccess, (state, { confirmRefundResponse }) => ({
    ...state,
    confirmRefundResponse: confirmRefundResponse,
  }))
);
